import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import { DocumentFileList } from "@/common/components/DocumentFileList";
import { cn } from "@/common/utils/cn";
import { getFilenameFromUrl } from "@/common/utils/getFilenameFromUrl";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { fiscalAssessmentDocumentGroupsKind } from "../../../../../features/fiscalAssessments/constants/fiscalAssessmentDocumentGroupsKind.constant";
import { MaintenanceFiscalAssessmentEntryStatus } from "../../../../../features/forwardings/types/forwardings/fiscalAssessmentEntry/fiscalAssessmentEntry.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../../../../../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useForwardingTabContext } from "../../../../../hooks/forwardings/useForwardingTabContext";

const MaintenanceWorkflowForwardingFiscalAssessmentEntrySection = () => {
  const { forwarding, forwardingUpdatedAt } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry
  >();

  const navigate = useNavigate();

  const isAwaitingEstablishmentDocuments = useMemo(() => {
    return forwarding?.fiscal_assessment_entry?.status === MaintenanceFiscalAssessmentEntryStatus.AwaitingEstablishmentDocuments;
  }, [forwardingUpdatedAt]);

  const isAwaitingManagementReview = useMemo(() => {
    return forwarding?.fiscal_assessment_entry?.status === MaintenanceFiscalAssessmentEntryStatus.AwaitingManagementReview;
  }, [forwardingUpdatedAt]);

  const isCompleted = useMemo(() => {
    return forwarding?.fiscal_assessment_entry?.status === MaintenanceFiscalAssessmentEntryStatus.Completed;
  }, [forwardingUpdatedAt]);

  return (
    <Box className={cn(
      'p-4 flex flex-col gap-4',
      isAwaitingManagementReview && 'bg-yellow-op-2',
    )}>
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">
            Recolha de notas
          </p>

          {isAwaitingEstablishmentDocuments && (
            <p className="text-warning text-xs">
              Aguardando notas
            </p>
          )}

          {isCompleted && (
            <p className="text-valid text-xs">
              Concluído
            </p>
          )}
        </div>

        {isAwaitingManagementReview && (
          <div>
            <Button
              onClick={() => navigate(`${forwarding.id}/fiscal-assessment/${forwarding.fiscal_assessment_entry.id}`)}
            >
              Revisar notas fiscais
            </Button>
          </div>
        )}
      </div>

      {isCompleted && (
        <div className="flex flex-col gap-3">
          {forwarding?.fiscal_assessment_entry?.document_groups?.map((documentGroup, index) => (
            <React.Fragment key={documentGroup.id}>
              {index > 0 && (
                <div className="h-px bg-white-200" />
              )}

              <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                  <div>
                    <p>
                      {fiscalAssessmentDocumentGroupsKind[documentGroup.kind] || documentGroup.kind}
                    </p>
                  </div>
                </div>

                {Number(documentGroup.documents.length) > 0 && (
                  <DocumentFileList
                    files={documentGroup.documents.map((document) => ({
                      currentFileUrl: document.file.url,
                      fileName: getFilenameFromUrl(document.file.url),
                    }))}
                    className="h-[120px] w-[220px] p-3 rounded-md"
                  />
                )}
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </Box>
  );
}

export default MaintenanceWorkflowForwardingFiscalAssessmentEntrySection;
